/**
 * Coarse, free-text-free error classification for analytics. CtrlApiError
 * messages can embed server payloads, so only the HTTP status is reported.
 */
export function errorCode(err: unknown): string {
  const status = (err as { status?: unknown } | null)?.status;
  if (typeof status === "number") return `http_${status}`;
  return "unknown";
}
